import { Expose, Type } from 'class-transformer';

export class EntityContactResponseDto {
    @Expose()
    id: string;

    @Expose()
    contactId: string;

    @Expose()
    entityId: string;

    @Expose()
    entityType: string;

    @Expose()
    roleDescription: string;

    @Expose()
    context: string;

    @Expose()
    @Type(() => Date)
    createdAt: Date;

    @Expose()
    @Type(() => Date)
    updatedAt: Date;
}
